import {
  FIRST_HAIRCARE_QUESTION_ROUTE,
  FIRST_SKINCARE_QUESTION_ROUTE,
} from 'Apps/Consultation/constants';

import { HAIRCARE_CART_URL, SKINCARE_CART_URL } from 'constants/urlCart';

import haircareImage from 'assets/images/promotionalModals/trial-offer-haircare-promotion-modal.jpg';
import defaultImage from 'assets/images/promotionalModals/trial-offer-promotion-modal.jpg';
import skincareImage from 'assets/images/promotionalModals/trial-offer-skincare-promotion-modal.jpg';

const content = {
  contentDefault: {
    banner: 'Subscribe for 50% off haircare and skincare',
    popUpModal: {
      image: defaultImage,
      badge: (
        <>
          50%
          <br />
          OFF
        </>
      ),
      headerTitle: 'exclusive offer',
      title: <>Get 50% off haircare and skincare + free shipping when you subscribe</>,
      description: '100% satisfaction guaranteed | Cancel any time',
      cta: {
        consultationCompleted: {
          linkTo: HAIRCARE_CART_URL,
          dataClick: 'order-your-prose',
          dataFrom: 'trial-offer-v2-hc-sc-pop-up',
          ctaLabel: 'Get 50% Off',
        },
        consultationNotCompleted: {
          linkTo: FIRST_HAIRCARE_QUESTION_ROUTE,
          dataClick: 'get-your-formula',
          dataFrom: 'trial-offer-v2-hc-sc-pop-up',
          ctaLabel: 'Get 50% Off',
        },
      },
      ctaExit: {
        dataClick: 'exit',
        dataFrom: 'trial-offer-v2-hc-sc-pop-up',
      },
      conditions:
        '*50% off your first subscription orders to haircare and skincare. All ongoing subscription orders are eligible for free shipping and 15% off. Subscribe to both haircare and skincare for a total ongoing subscription discount of 20%. Promotion cannot be applied to previous orders, existing subscriptions, and non-subscribed products. On-hold subscriptions that are reactivated during the promotional period are not eligible for the promotion. Not valid for accessories (hair towels, candles, and brushes [US only]), or digital gift cards. Offer subject to expire.',
      tracking: {
        modalClosing: 'Trial Offer v2 HC + SC Pop-up - Closed',
        modalOpening: 'Trial Offer v2 HC + SC Pop-up - Viewed',
        modalOpening2sec: 'Trial Offer v2 HC + SC Pop-up - Viewed (2 seconds)',
      },
    },
    bottomModal: {
      title: 'Exclusive Offer',
      description: (
        <>
          Get <b>50% off</b> haircare and skincare
          <br />+ <b>free shipping</b> when you subscribe
        </>
      ),
      conditions:
        '*50% off your first subscription orders to haircare and skincare. All ongoing subscription orders are eligible for free shipping and 15% off. Subscribe to both haircare and skincare for a total ongoing subscription discount of 20%. Promotion cannot be applied to previous orders, existing subscriptions, and non-subscribed products. On-hold subscriptions that are reactivated during the promotional period are not eligible for the promotion. Not valid for accessories (hair towels, candles, and brushes [US only]), or digital gift cards. Offer subject to expire.',
    },
    checkoutCommunication: {
      title: 'exclusive offer',
      description: (
        <>
          Get <b>50% off</b> haircare and skincare
          <br />+ <b>free shipping</b> when you subscribe
        </>
      ),
      terms: 'See terms & conditions',
    },
  },
  contentHaircare: {
    banner: 'Subscribe for 50% off haircare + free shipping',
    popUpModal: {
      image: haircareImage,
      badge: (
        <>
          50%
          <br />
          OFF
        </>
      ),
      headerTitle: 'exclusive offer',
      title: <>Get 50% off haircare + free shipping when you subscribe</>,
      description: '100% satisfaction guaranteed | Cancel any time',
      cta: {
        consultationCompleted: {
          linkTo: HAIRCARE_CART_URL,
          dataClick: 'order-your-prose',
          dataFrom: 'trial-offer-v2-hc-pop-up',
          ctaLabel: 'Get 50% Off',
        },
        consultationNotCompleted: {
          linkTo: FIRST_HAIRCARE_QUESTION_ROUTE,
          dataClick: 'get-your-formula',
          dataFrom: 'trial-offer-v2-hc-pop-up',
          ctaLabel: 'Get 50% Off',
        },
      },
      ctaExit: {
        dataClick: 'exit',
        dataFrom: 'trial-offer-v2-hc-pop-up',
      },
      conditions:
        '*50% off your first haircare subscription order. All ongoing subscription orders are eligible for free shipping and 15% off. Subscribe to both haircare and skincare for a total ongoing subscription discount of 20%. Promotion cannot be applied to previous orders, existing subscriptions, and non-subscribed products. On-hold subscriptions that are reactivated during the promotional period are not eligible for the promotion. Not valid for accessories (hair towels, candles, and brushes [US only]), or digital gift cards. Offer subject to expire.',
      tracking: {
        modalClosing: 'Trial Offer v2 HC Pop-up - Closed',
        modalOpening: 'Trial Offer v2 HC Pop-up - Viewed',
        modalOpening2sec: 'Trial Offer v2 HC Pop-up - Viewed (2 seconds)',
      },
    },
    bottomModal: {
      title: 'Exclusive Offer',
      description: (
        <>
          Get <b>50% off</b> haircare + <b>free shipping</b>
          <br />
          when you subscribe
        </>
      ),
      conditions:
        '*50% off your first haircare subscription order. All ongoing subscription orders are eligible for free shipping and 15% off. Subscribe to both haircare and skincare for a total ongoing subscription discount of 20%. Promotion cannot be applied to previous orders, existing subscriptions, and non-subscribed products. On-hold subscriptions that are reactivated during the promotional period are not eligible for the promotion. Not valid for accessories (hair towels, candles, and brushes [US only]), or digital gift cards. Offer subject to expire.',
    },
    checkoutCommunication: {
      title: 'exclusive offer',
      description: (
        <>
          Get <b>50% off</b> haircare + <b>free shipping</b>
          <br />
          when you subscribe
        </>
      ),
      terms: 'See terms & conditions',
    },
  },
  contentSkincare: {
    banner: 'Subscribe for 50% off skincare + free shipping',
    popUpModal: {
      image: skincareImage,
      badge: (
        <>
          50%
          <br />
          OFF
        </>
      ),
      headerTitle: 'exclusive offer',
      title: <>Get 50% off skincare + free shipping when you subscribe</>,
      description: '100% satisfaction guaranteed | Cancel any time',
      cta: {
        consultationCompleted: {
          linkTo: SKINCARE_CART_URL,
          dataClick: 'order-your-prose',
          dataFrom: 'trial-offer-v2-sc-pop-up',
          ctaLabel: 'Get 50% Off',
        },
        consultationNotCompleted: {
          linkTo: FIRST_SKINCARE_QUESTION_ROUTE,
          dataClick: 'get-your-formula',
          dataFrom: 'trial-offer-v2-sc-pop-up',
          ctaLabel: 'Get 50% Off',
        },
      },
      ctaExit: {
        dataClick: 'exit',
        dataFrom: 'trial-offer-v2-sc-pop-up',
      },
      conditions:
        '*50% off your first skincare subscription order. All ongoing subscription orders are eligible for free shipping and 15% off. Subscribe to both haircare and skincare for a total ongoing subscription discount of 20%. Promotion cannot be applied to previous orders, existing subscriptions, and non-subscribed products. On-hold subscriptions that are reactivated during the promotional period are not eligible for the promotion. Not valid for accessories (hair towels, candles, and brushes [US only]), or digital gift cards. Offer subject to expire.',
      tracking: {
        modalClosing: 'Trial Offer v2 SC Pop-up - Closed',
        modalOpening: 'Trial Offer v2 SC Pop-up - Viewed',
        modalOpening2sec: 'Trial Offer v2 SC Pop-up - Viewed (2 seconds)',
      },
    },
    bottomModal: {
      title: 'Exclusive Offer',
      description: (
        <>
          Get <b>50% off</b> skincare + <b>free shipping</b>
          <br />
          when you subscribe
        </>
      ),
      conditions:
        '*50% off your first skincare subscription order. All ongoing subscription orders are eligible for free shipping and 15% off. Subscribe to both haircare and skincare for a total ongoing subscription discount of 20%. Promotion cannot be applied to previous orders, existing subscriptions, and non-subscribed products. On-hold subscriptions that are reactivated during the promotional period are not eligible for the promotion. Not valid for accessories (hair towels, candles, and brushes [US only]), or digital gift cards. Offer subject to expire.',
    },
    checkoutCommunication: {
      title: 'exclusive offer',
      description: (
        <>
          Get <b>50% off</b> skincare + <b>free shipping</b>
          <br />
          when you subscribe
        </>
      ),
      terms: 'See terms & conditions',
    },
  },
};

export default content;
